import { Divider, List, Stack, Typography, useTheme } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useEffect, useRef } from 'react'

import type { SearchResult } from '../types'
import { QuickSearchResultItem, getActionLabel } from './QuickSearchResultItem'

type RecentlyViewedListProps = {
  activeIndex: number
  results: SearchResult[]
  onSelect: (index: number) => void
}

export default function RecentlyViewedList({ activeIndex, results, onSelect }: RecentlyViewedListProps) {
  const t = useTranslations('quickSearch')
  const theme = useTheme()
  const activeItemRef = useRef<HTMLLIElement | null>(null)

  useEffect(() => {
    activeItemRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
  }, [activeIndex])

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        px={4}
        py={1}
        sx={{ backgroundColor: theme.palette.background.paper }}
      >
        <Typography variant="overline" fontWeight={600}>
          {t('categories.recentlyViewed')}
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Stack>
      <List dense disablePadding>
        {results.map((result, index) => (
          <QuickSearchResultItem
            key={`${result.category}:${result.id}`}
            ref={index === activeIndex ? activeItemRef : null}
            result={result}
            selected={index === activeIndex}
            actionLabel={getActionLabel(result.category, t)}
            onSelect={() => onSelect(index)}
          />
        ))}
      </List>
    </>
  )
}
